import React, { useState, useEffect } from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import { Button, Markdown, Card } from '../elements';
import FilterOption from '../category/FilterOption';

const AllNewsSection = ({ loadMore, title }) => {
  // getting 3 articles data form graphql
  const { allSanityArticles } = useStaticQuery(graphql`
    {
      allSanityArticles(sort: { fields: date, order: DESC }) {
        nodes {
          id
          title
          date
          articleSubtitle
          slug {
            current
          }
          featuredImage {
            alt
            asset {
              _id
              gatsbyImageData(width: 392, height: 260)
            }
          }
          categories {
            title
          }
        }
      }
    }
  `);

  // array of all articles
  const allNews = allSanityArticles.nodes;
  // state for the loading item
  const [list, setList] = useState([...allNews.slice(0, 9)]);

  // state to trigger oad more
  const [articleLoadMore, setLoadMore] = useState(false);

  // state of whether there is more to load
  const [hasMore, setHasMore] = useState(allNews.length > 9);

  // load more button click
  const handleLoadMore = () => {
    setLoadMore(true);
  };

  // handle loading more articles
  useEffect(() => {
    if (articleLoadMore && hasMore) {
      const currentLength = list.length;
      const isMore = currentLength < allNews.length;
      const nextResults = isMore
        ? allNews.slice(currentLength, currentLength + 9)
        : [];
      setList([...list, ...nextResults]);
      setLoadMore(false);
    }
  }, [articleLoadMore, hasMore]);

  useEffect(() => {
    const isMore = list.length < allNews.length;
    setHasMore(isMore);
  }, [list]);

  return (
    <>
      <FilterOption />
      <section className="section">
        <div className="container">
          {title && (
            <div className="columns is-centered mb-5">
              <div className="column is-8 has-text-centered">
                <Markdown className="pb-2 has-text-grey-dark">{title}</Markdown>
              </div>
            </div>
          )}
          <div className="columns is-multiline">
            {list.map((article) => (
              <Card
                image={article.featuredImage.asset.gatsbyImageData}
                alt={article.featuredImage.asset.alt || 'Capextax'}
                title={article.title}
                key={article.id}
                date={article.date}
                subtitle={article.articleSubtitle}
                slug={`/news/${
                  article.slug.current === 'homepage'
                    ? '/'
                    : article.slug.current
                }`}
              />
            ))}
          </div>
          {hasMore ? (
            <Button fullWidth type="button" onClick={handleLoadMore}>
              {loadMore}
            </Button>
          ) : null}
        </div>
      </section>
    </>
  );
};

export default AllNewsSection;
